import '@vant/touch-emulator'
import { Toast, Dialog } from 'vant'
import 'vant/es/toast/style/index'
import 'vant/es/dialog/style/index'
import { i18n } from 'app-core/lib/i18n'
export default function (Vue) {
  Vue.use(Toast)
  Vue.use(Dialog)

  Vue.config.globalProperties.$w = {
    confirm: {
      show: function (options) {
        if (typeof options === 'object' && options.onShow) {
          options.onShow && options.onShow()
        }
        Dialog.confirm({
          title: options.title,
          message: options.content,
          confirmButtonText: options.confirmText || i18n.t('APP_HOME.que-ren'),
          cancelButtonText: options.cancelText || i18n.t('APP_HOME.qu-xiao'),
          showCancelButton: options.showCancelButton == undefined ? true : false,
          showConfirmButton: options.showConfirmButton == undefined ? true : false,
          closeOnClickOverlay: options.hideOnBlur == undefined ? true : false,
          confirmButtonColor: 'var(--main-color)',
          cancelButtonColor: options.cancelButtonColor,
          messageAlign: options.messageAlign,
          allowHtml: true
        })
          .then(options.onConfirm)
          .catch(options.onCancel)
          .finally(() => {
            options.onHide && options.onHide()
          })
      }
    },
    alert: {
      show: function (options) {
        let conf = {}
        if (typeof options == 'object') {
          conf = options
        } else if (typeof options == 'string') {
          conf = { content: options }
        }
        Dialog.alert({
          title: conf.title,
          message: conf.content,
          messageAlign: conf.messageAlign || 'center',
          confirmButtonText: conf.buttonText || i18n.t('APP_HOME.que-ren'),
          closeOnClickOverlay: conf.hideOnBlur == undefined ? true : false,
          confirmButtonColor: 'var(--main-color)'
        }).then(conf.onHide)
      }
    },
    toast: {
      show: function (options = {}) {
        Toast({
          type: options.type,
          message: options.text,
          position: options.position || 'middle',
          duration: options.time || 2000,
          overlay: options.isShowMask || false,
          onClose: options.onHide
          // forbidClick: false
        })
      },
      hide: function () {
        Toast.clear()
      },
      text: function (text, position = '') {
        Toast({
          message: text,
          position: position || 'middle'
        })
      }
    },
    loading: {
      show: function (options = {}) {
        Toast.loading({
          duration: 0,
          icon: $ZConfig.getVal('LOGO_WHITE'),
          message: options.text,
          forbidClick: true
        })
      },
      hide: function () {
        Toast.clear()
      }
    }
  }
}
